import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import appFetch from '../../../../api/appFetch.js';
import { WorkshopPlanningIndicatorsToOutletUsersUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import OutletUsersDropdown from '../../../Common/Dropdowns/OutletUsersDropdown.js';
import IndicatorsDropdown from '../../../Common/Dropdowns/IndicatorsDropdown.js';

export default class LinkIndicatorsCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            outletId: 0,
            outletUserId: 0,
            indicatorId: 0,
            outletUsers: [],
            indicators: [],
            redirect: null,
            linkedIndicatorWasCreated: false,
            requestInProgress: false,
        };
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/linkedindicators" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value, indicatorId: 0 });
    };

    handleChangeOutletUser = e => {
        this.setState({ outletUserId: e.target.value });
    };

    handleChangeIndicator = e => {
        this.setState({ indicatorId: e.target.value });
    };

    handleSubmit = () => {
        this.setState({ requestInProgress: true });
        const { resources } = this.props;

        var json = JSON.stringify({
            moboOutletId: this.state.outletId,
            outletUserId: this.state.outletUserId,
            workshopPlanningIndicatorId: this.state.indicatorId
        });

        var url = WorkshopPlanningIndicatorsToOutletUsersUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data, response) => {
                DisplayMessage(resources["LinkedIndicatorsSuccessfullyCreated"], "success");
                this.setState({ redirect: (response.ok ? '/linkedindicators' : null), linkedIndicatorWasCreated: response.ok });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSubmit();
    };

    renderForm() {
        var resources = this.props.resources;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form onSubmit={this.handleFormSubmit} >

                    <Form.Group className="pt-3" style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={this.state.outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6"
                            defaultValue={resources["SelectOutlet"]}
                            helperText={resources["SelectionOfOutletIsMandatory"]}
                            required={this.props.accessibleMoboOutlets.length > 0}
                        />
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <OutletUsersDropdown
                            resources={resources}
                            outletUser={this.state.outletUserId}
                            onOutletUserChange={this.handleChangeOutletUser}
                            onRequestStart={() => this.setState({ requestInProgress: true })}
                            onRequestEnd={() => this.setState({ requestInProgress: false })}
                            containerClass="col-md-6"
                            defaultValue={resources["Select"]}
                            helperText={resources["SelectionOfUserIsMandatory"]}
                            required
                        />
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <IndicatorsDropdown
                            resources={resources}
                            indicator={this.state.indicatorId}
                            outletId={this.state.outletId}
                            onIndicatorChange={this.handleChangeIndicator}
                            onRequestStart={() => this.setState({ requestInProgress: true })}
                            onRequestEnd={() => this.setState({ requestInProgress: false })}
                            containerClass="col-md-6"
                            defaultValue={resources["Select"]}
                            helperText={resources["IsMandatory"]}
                            required
                        />
                    </Form.Group>
                </Form>
            </Paper >
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            <div className="pt-4">
                {this.renderForm()}
            </div>
        </div>;
    }

    render() {
        const { redirect, open, linkedIndicatorWasCreated, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || redirect || (!this.state.outletId || !this.state.outletUserId || !this.state.indicatorId);

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: linkedIndicatorWasCreated } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-add-linked-indicator" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["NewLink"]}
                            </Typography>
                            <Button id="linked-indicators-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}